module.exports = __webpack_public_path__ + "img/LogoDashboard-29.8500fb11.svg";